// Import Bootstrap JS bundle (includes Popper)
import 'bootstrap';

$(window).on('scroll', function() {
  const scroll = $(window).scrollTop();
  const header = $('.subpage .navbar');
  if (scroll > 150) {
    header.addClass('bg-dark').removeClass('bg-transparent');
  } else {
    header.removeClass('bg-dark').addClass('bg-transparent');
  }
});

$('#slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1
});